import { render } from "./JobDetail.vue?vue&type=template&id=6399e5ea&scoped=true"
import script from "./JobDetail.vue?vue&type=script&lang=js"
export * from "./JobDetail.vue?vue&type=script&lang=js"

import "./JobDetail.vue?vue&type=style&index=0&id=6399e5ea&scoped=true&lang=css"
import "./JobDetail.vue?vue&type=style&index=1&id=6399e5ea&lang=scss"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6399e5ea"]])

export default __exports__